module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/JFK.2c95f63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/JFK.jpg
// module id = RLff
// module chunks = 0